import React from "react";

export default function JS_Getters_Setters() {
  return (
    <div className="tutorial-container">
      <h1>JS Getters Setters</h1>
      <p>
        This tutorial explains the concept of JS Getters Setters in JavaScript
        OOPs.
      </p>
    </div>
  );
}
